import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import StatCardGroup from "../Common/StatCardGroup";
import MembershipGrowthChart from "./MembershipGrowthChart";
import SentimentAnalysis from "./SentimentAnalysis";
import DonutDistribution from "../Common/DonutDistribution";
import RevenueSplit from "./RevenueSplit";
import { primaryColor } from "utils/dashboardUtils";
import RecentActivity from "./RecentActivity";
import { useSelector } from "react-redux";

const Customers = ({ activeFilterType = "" }) => {
  const { t } = useTranslation();
  // Stats Data
  const statsData = useSelector((state) => state.Dashboard?.data?.stats);
  const customerData = statsData?.stats;
  // Charts Data
  const chartsData = useSelector((state) => state.Dashboard?.data?.charts);
  const membershipGrowthData = chartsData?.membershipGrowth;
  const feedbacks = chartsData?.feedbacks;

  // donutChart Data
  const donutChartData = useSelector(
    (state) => state.Dashboard?.data?.donutChart,
  );
  const membershipDistributionData = donutChartData?.membershipDistribution;
  const singleWashDistributionData = donutChartData?.singleWashDistribution;
  const revenueSplitData = donutChartData?.revenueSplit;
  const DASHBOARD_STATS = [
    {
      id: "totalCustomers",
      title: t("Total Leads"),
      value: customerData?.totalLeads ?? 0,
      icon: "totalCustomers",
      month: t("Current Month"),
    },
    {
      id: "newCustomer",
      title: t("Total Customers"),
      value: customerData?.totalCustomers ?? 0,
      icon: "newCustomer",
      month: t("Current Month"),
    },
    {
      id: "churnRate",
      title: t("Churn Rate"),
      value: customerData?.churnRate ?? t("0%"),
      icon: "churnRate",
    },
    {
      id: "appAdoptionRate",
      title: t("App Adoption Rate"),
      value: customerData?.appAdoptionRate ?? t("0%"),
      icon: "appAdoptionRate",
    },
    {
      id: "newMembership",
      title: t("New Membership"),
      value: customerData?.newMemberships ?? 0,
      icon: "newMembership",
    },
    {
      id: "retentionRate",
      title: t("Retention Rate"),
      value: customerData?.retentionRate ?? t("0%"),
      icon: "retentionRate",
    },
    {
      id: "customerLifetimeValue",
      title: t("Customer Lifetime Value"),
      value: customerData?.customerLifetimeValue ?? "$0",
      icon: "customerLifetimeValue",
    },
    {
      id: "usageRate",
      title: t("Membership Usage Rate"),
      value: customerData?.membershipUsagePercentage ?? t("0%"),
      icon: "usageRate",
    },
  ];

  const PLAN_COLORS = {
    "Unlimited Shine": "#F3AA41",
    "Unlimited Protect": "#523677",
    "Unlimited The Works": "#DE235C",
    "Unlimited Shine Wash Plan": "#6BC4A8",
    "Basic Wash": "#4F46E5",
    "Premium Gold Plan": "#D4AF37",
    "Test Plan": "#9CA3AF",
  };

  const MEMBERSHIP_DISTRIBUTION = membershipDistributionData?.map((item) => ({
    name: item.planTitle?.en || item.label,
    value: item.value,
    color: PLAN_COLORS[item.planTitle?.en || item.label] || "#CBD5E1",
  }));

  const WASH_COLORS = {
    Shine: "#F3AA41",
    Clean: "#4F46E5",
    Protect: "#523677",
    "Gold Wash": "#D4AF37",
    Works: "#DE235C",
  };

  const SINGLE_WASH_DISTRIBUTION = singleWashDistributionData?.map((item) => ({
    name: item.washType?.en || item.label,
    value: item.value,
    color: WASH_COLORS[item.washType?.en || item.label] || "#CBD5E1",
  }));

  const REVENUE_SPLIT_DATA = [
    {
      label: t("Memberships"),
      value: revenueSplitData?.memberships,
      color: primaryColor,
    },
    {
      label: t("Single Wash"),
      value: revenueSplitData?.singleWash,
      color: "#F6A04D",
    },
  ];

  return (
    <div className="customers_dashboard">
      <StatCardGroup items={DASHBOARD_STATS} />
      <Row>
        <Col xxl={8} xl={7}>
          <MembershipGrowthChart membershipGrowth={membershipGrowthData} activeFilterType={activeFilterType} />
        </Col>
        <Col xxl={4} xl={5}>
          <SentimentAnalysis feedbacks={feedbacks} />
        </Col>
      </Row>
      <Row>
        <DonutDistribution
          title={t("Membership Distribution")}
          data={MEMBERSHIP_DISTRIBUTION || []}
        />
        <DonutDistribution
          title={t("Single Wash Distribution")}
          data={SINGLE_WASH_DISTRIBUTION || []}
        />
        <RevenueSplit title={t("Revenue Split")} data={REVENUE_SPLIT_DATA} />
      </Row>
      <Row>
        <Col lg={12}>
          <RecentActivity />
        </Col>
      </Row>
    </div>
  );
};

export default Customers;
